import * as t from './actionTypes';
import { fetchInboundSMSResponse } from './actions';
import type { InboundSMSReducerState } from './types';

type InboundSMSReducerActionType = ReturnType<typeof fetchInboundSMSResponse>;

export const initialInboundMessageState: InboundSMSReducerState['insights']['inboundSMS'] = {
  inboundSMSMessages: [],
};

const inboundSMSReducer = (
  state = initialInboundMessageState,
  action: InboundSMSReducerActionType,
) => {
  switch (action.type) {
    case t.FETCH_INBOUND_SMS_RESPONSE: {
      return {
        ...state,
        inboundSMSMessages: action.response,
      };
    }
    default: {
      return state;
    }
  }
};

export default inboundSMSReducer;
